import { LitElement, html, css } from 'lit-element';
import { fetchOrders, promptUpsell } from '../core/actions';
import { connect } from '../core/connect';
import { auth } from '../core/props';
import { withProduct } from '../core/resolveProperties';

export class UpsellButton extends withProduct(LitElement) {
  static get styles() {
    return css`
      :host[hidden] {
        display: none;
      }

      :host {
        display: inline-block;
      }
      :host button {
        font-family: var(--og-upsell-font-familiy, inherit);
        font-size: var(--og-upsell-font-size, inherit);
        background-color: var(--og-upsell-background-color, inherit);
        color: var(--og-upsell-font-color, inherit);
      }
    `;
  }

  static get properties() {
    return {
      ...super.properties,
      upcomingOrderDate: {
        type: String,
        attribute: false
      },
      auth: auth,
      isPreview: { type: Boolean, attribute: false }
    };
  }

  constructor() {
    super();
    this.fetchOrders = () => 0;
    this.addEventListener('click', this.handleClick.bind(this));
  }

  updated(changed) {
    if (changed.has('auth') && this.auth && !this.upcomingOrderDate && !this.isPreview) {
      this.fetchOrders();
    }
  }

  handleClick() {
    this.promptUpsell(this.product);
  }

  render() {
    return html`
      <slot name="default">
        <label for="upsellButton"><og-text key="upsellButtonLabel"></og-text></label>
        <button name="upsellButton">
          <og-text key="upsellButtonContent"></og-text>
          <og-next-upcoming-order></og-next-upcoming-order>
        </button>
      </slot>
    `;
  }
}

export const mapStateToProps = state => ({
  isPreview: state.previewUpsellOffer
});

export const ConnectedUpsellButton = connect(
  mapStateToProps,
  {
    fetchOrders,
    promptUpsell
  }
)(UpsellButton);

export default UpsellButton;
